$(document).on('click', '.halskette-product-add-btn.add-to-cart.disabled', function(event){
event.preventDefault();
var properties_name = $('.properties_name').val();
var properties_ruckseite = $('.properties_ruckseite').val();
if(properties_name == ''){
$('.properties_name').parents('.select-trigger').addClass('error-text');
}
  if(properties_ruckseite == ''){
$('.properties_ruckseite').parents('.select-trigger').addClass('error-text');
}
$('.error').show();
});

$('.properties_name').on('keyup', function(){
var properties_name = $('.properties_name').val();
var errorTextLength = $('.error-text').length;
if(errorTextLength == 0){
$('.add-to-cart').removeClass('disabled');
  $('.error').hide();
}
if(properties_name == ''){
$('.add-to-cart').addClass('disabled');
}else{
$(this).parents('.select-trigger').removeClass('error-text');
}
});

$('.properties_ruckseite').on('keyup', function(){
  var properties_ruckseite = $('.properties_ruckseite').val();


  

var errorTextLength = $('.error-text').length;
if(errorTextLength == 0){
$('.add-to-cart').removeClass('disabled');
   $('.error').hide();
}
  if(properties_ruckseite == ''){
$('.add-to-cart').addClass('disabled');
}else{
$(this).parents('.select-trigger').removeClass('error-text');
}
});


function addHalsketteProduct(){

}

